//frontend/src/pages/history/historystages/AncientCivilisations.jsx
import React from 'react';
import JourneyPage from '../../../components/SubjectsPage';
import historyImage from '../../../assets/history2/Historical_Topics_-_20th_Century.png';

const subTopics = [
  { name: 'World War I', route: '/History-World-War-I', key: 'World War I' },
  { name: 'World War II', route: '/History-World-War-II', key: 'World War II' },
  { name: 'Cold War', route: '/History-Cold-War', key: 'Cold War' },
  { name: 'USSR & Revolution', route: '/History-Russian-Revolution', key: 'Russian Revolution & USSR' },
  { name: 'Indian Independence', route: '/History-Indian-Independence', key: 'Indian Independence' },
  { name: 'African Independence Movements', route: '/History-African-Independence', key: 'African Independence Movements' },
  { name: 'Rise of Fascism and Nazism', route: '/History-Rise-Fascism-Nazism', key: 'Rise of Fascism and Nazism' },
];


function HistoryPage20th() {
  return (
    <JourneyPage
      title="The 20th century"
      backgroundImage={historyImage}
      subTopics={subTopics}
      backRoute="/history2"
      chapterFooter=""
    />
  );
}

export default HistoryPage20th;
